/* tslint:disable */
/* eslint-disable */
/**
 * pkg/api/event.proto
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: version not set
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    ApiPriorityClassPoolResourceLimits,
    ApiPriorityClassPoolResourceLimitsFromJSON,
    ApiPriorityClassPoolResourceLimitsFromJSONTyped,
    ApiPriorityClassPoolResourceLimitsToJSON,
} from './ApiPriorityClassPoolResourceLimits';

/**
 * 
 * @export
 * @interface ApiPriorityClassResourceLimits
 */
export interface ApiPriorityClassResourceLimits {
    /**
     * Limits resources assigned to jobs of this priority class.
     * Specifically, jobs of this priority class are only scheduled if doing so does not exceed this limit.
     * @type {{ [key: string]: number; }}
     * @memberof ApiPriorityClassResourceLimits
     */
    maximumResourceFraction?: { [key: string]: number; };
    /**
     * Per-pool override of maximum_resource_fraction.
     * If missing for a particular pool, maximum_resource_fraction is used instead for that pool.
     * @type {{ [key: string]: ApiPriorityClassPoolResourceLimits; }}
     * @memberof ApiPriorityClassResourceLimits
     */
    maximumResourceFractionByPool?: { [key: string]: ApiPriorityClassPoolResourceLimits; };
}

export function ApiPriorityClassResourceLimitsFromJSON(json: any): ApiPriorityClassResourceLimits {
    return ApiPriorityClassResourceLimitsFromJSONTyped(json, false);
}

export function ApiPriorityClassResourceLimitsFromJSONTyped(json: any, ignoreDiscriminator: boolean): ApiPriorityClassResourceLimits {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'maximumResourceFraction': !exists(json, 'maximumResourceFraction') ? undefined : json['maximumResourceFraction'],
        'maximumResourceFractionByPool': !exists(json, 'maximumResourceFractionByPool') ? undefined : (mapValues(json['maximumResourceFractionByPool'], ApiPriorityClassPoolResourceLimitsFromJSON)),
    };
}

export function ApiPriorityClassResourceLimitsToJSON(value?: ApiPriorityClassResourceLimits | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'maximumResourceFraction': value.maximumResourceFraction,
        'maximumResourceFractionByPool': value.maximumResourceFractionByPool === undefined ? undefined : (mapValues(value.maximumResourceFractionByPool, ApiPriorityClassPoolResourceLimitsToJSON)),
    };
}

